import type { Car } from "@views/Upholstery/types"
import { useUpholsteryDataStore } from "@views/Upholstery/store/store"
import { isPdmStructureV2Enabled } from "../flags/isPdmStructureV2Enabled"
import { usePdmVehicleCatalogStore } from "../../store/pdm-vehicle-catalog-store"

/**
 * Reactive vehicle list for picker / navbar UI.
 * V2 on → PDM-derived `pickerCars`; legacy → Dato `UpholsteryDataStore.cars`.
 */
export function useUpholsteryVehicleList(): Car[] {
  const isV2 = isPdmStructureV2Enabled()
  const datoCars = useUpholsteryDataStore((s) => s.cars)
  const pickerCars = usePdmVehicleCatalogStore((s) => s.pickerCars)
  return isV2 ? pickerCars : datoCars
}

/**
 * Snapshot for async handlers (e.g. navbar saveVehicle).
 * V2 on → PDM-derived `pickerCars`; legacy → Dato `UpholsteryDataStore.cars`.
 */
export function getUpholsteryVehicleList(): Car[] {
  if (isPdmStructureV2Enabled()) {
    return usePdmVehicleCatalogStore.getState().pickerCars
  }
  return useUpholsteryDataStore.getState().cars
}
